import React from 'react';
import PropTypes from 'prop-types';
import AdjuntoList from '../../commons/AdjuntoList';

const MaintenanceBook = ({ equipment }) => {
  return (
    <div>
      {equipment.mn?.map((m) => (
        <React.Fragment key={m.mn}>
          <h3>{`Manuales: ${m.cm} - ${m.nm}`}</h3>
          <AdjuntoList
            data={m.dm.dtl.map((a) => ({
              id: a.cr,
              name: a.na,
              extension: a.ea,
              state: a.st,
            }))}
            file={m.dm.ar}
            hideToolBar
          />
        </React.Fragment>
      ))}
    </div>
  );
};

MaintenanceBook.propTypes = {
  equipment: PropTypes.object,
};

export default MaintenanceBook;
